import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["messages"]

  connect() {
    this.scrollToBottom();
  }

  messagesTargetConnected(element) {
    this.observer = new MutationObserver(() => this.scrollToBottom())
    this.observer.observe(element, { childList: true, subtree: true })
  }

  messagesTargetDisconnected() {
    this.observer?.disconnect()
  }

  scrollToBottom() {
    if (this.hasMessagesTarget) {
      this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight;
    }
  }
}
